import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ScenarioLibraryComponent } from './dashboard/scenario-library/scenario-library.component';
import { ScenarioCreationComponent } from './scenario-creation/scenario-creation.component';
import { BaseScenarioComponent } from './scenario-creation/base-scenario/base-scenario.component';
import { OutputSummaryComponent } from './scenario-creation/output-summary/output-summary.component';
import { HeaderComponent } from './header/header.component';
import { LoaderComponent } from './loader/loader.component';
import { AuthResponseComponent } from './auth-response/auth-response.component';
import { FilterGroupComponent } from './filters/filter-group/filter-group.component';
import { MultipleCheckBoxFilterComponent } from './filters/multiple-check-box-filter/multiple-check-box-filter.component';
import { ScenarioBuilderComponent } from './scenario-creation/scenario-builder/scenario-builder.component';
import { PeriodPickerComponent } from './shared/period-picker/period-picker.component';
import { ConsistencyCheckComponent } from './scenario-creation/consistency-check/consistency-check.component';
import { BaseScenarioDetailsComponent } from './scenario-creation/base-scenario-details/base-scenario-details.component';
import { ThreeDecimalsPipe } from './three-decimals.pipe';
import { ExtractYearWeekPipe } from './extract-year-week.pipe';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatDialogModule } from '@angular/material/dialog';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { environment } from 'src/environments/environment';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTreeModule } from '@angular/material/tree';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { CdkTableModule } from '@angular/cdk/table';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { NewFeatureComponent } from './new-feature/new-feature.component';
import { PeDecomComponent } from './scenario-creation/pe-decom/pe-decom.component';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;
console.log('isIE :: ', isIE);

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ScenarioLibraryComponent,
    ScenarioCreationComponent,
    BaseScenarioComponent,
    OutputSummaryComponent,
    HeaderComponent,
    LoaderComponent,
    AuthResponseComponent,
    ThreeDecimalsPipe,
    FilterGroupComponent,
    MultipleCheckBoxFilterComponent,
    ScenarioBuilderComponent,
    ExtractYearWeekPipe,
    PeriodPickerComponent,
    ConsistencyCheckComponent,
    BaseScenarioDetailsComponent,
    NewFeatureComponent,
    PeDecomComponent,
    // DetailsModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatSelectModule,
    MatDividerModule,
    MatTableModule,
    FormsModule,
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatDialogModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatTreeModule,
    CdkTreeModule,
    MatTableModule,
    MatInputModule,
    MatStepperModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatSortModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatMenuModule,
    MatChipsModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HighchartsChartModule,
    MatSelectModule,
    CdkTableModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatDialogModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.client_id, // This is your client ID
          authority: environment.tenant_autority, // This is your tenant ID
          redirectUri: environment.redirect_url,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
        },
      }),
      {
        interactionType: InteractionType.Redirect, // MSAL Guard Configuration
        authRequest: {
          scopes: ['user.read'],
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          // ['Enter_the_Graph_Endpoint_Here/v1.0/me',['user.read']],
          ['https://graph.microsoft.com/v1.0/me', ['user.read']],
          [environment.api_base_url, ['user.read']],
        ]),
      },
    ),
  ],
  providers: [
    MsalGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    DatePipe,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
